import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

import ResetPassword from '../views/ResetPassword'
import firebase from 'firebase'

import User from '../views/User'

import PriceFinder from '../views/PriceFinder'
import ResidualValueCalculator from '../views/ResidualValueCalculator'
// import PriceValuation from '../views/PriceValuation'
import MyProfile from '../views/MyProfile'
import DashboardAnalytics from '../views/DashboardAnalytics'
import Impressum from '../views/Impressum'
import Datenschutz from '../views/Datenschutz'
import Preisbewertung from '../views/Preisbewertung'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPassword,
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Impressum,
  },
  {
    path: '/datenschutz',
    name: 'datenschutz',
    component: Datenschutz,
  },
  {
    path: '/user',
    name: 'user',
    component: User,
    children:[  
    {
      path: 'preisfinder',
      name: 'priceFinder',
      component: PriceFinder
    },
    {
      path: 'restwertkalkulator',
      name: 'residualValueCalculator',
      component: ResidualValueCalculator,
    },
    // {
    //   path: 'preisbewertung',
    //   name: 'priceValuation',
    //   component: PriceValuation,
    // },
    {
      path: 'preisbewertung',
      name: 'preisbewertung',
      component: Preisbewertung,
    },
    {
      path: 'profile',
      name: 'myProfile',
      component: MyProfile,
    },
    {
      path: 'dashboard',
      name: 'dashboard',
      component: DashboardAnalytics,
    },

    ],
    meta: {
      requiresAuth: true
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!firebase.auth().currentUser){
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } 
  else {
    next()
  }
})

export default router